import React from 'react'
import { Col, Row } from 'reactstrap'
import Address from 'src/components/Address'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { StaffingAgencyRemitDetailsById } from 'src/queries'

interface ListProps {
  agency: StaffingAgencyRemitDetailsById | undefined
}

const List: React.FC<ListProps> = (props) => {
  const { agency } = props
  const remit = agency?.staffingAgency?.remit ?? {}

  const section1: Array<Omit<ItemProps, 'id'>> = [
    { title: 'Remit Name', value: remit.name },
    {
      title: 'Remit Address',
      value: (<Address address={remit.address} />)
    },
    { title: 'Payment Details', value: remit.paymentDetails },
    { title: 'Payment Terms', value: remit.paymentTerms }
  ]
  const dlProps = {
    className: 'row-cols-1',
    suspended: agency === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  return (
    <Row>
      <Col>
        <DescriptionList {...dlProps}>
          {section1.map(item => {
            const key = item.title.toLowerCase().replace(' ', '-')
            return <Item {...item} key={key} id={key} />
          })}
        </DescriptionList>
      </Col>
    </Row>
  )
}

export default List
